/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupexport1Inputs */

const en_signupexport1 = /** @type {(inputs: Signupexport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export CSV`)
};

const de_signupexport1 = /** @type {(inputs: Signupexport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV exportieren`)
};

/**
* | output |
* | --- |
* | "Export CSV" |
*
* @param {Signupexport1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupexport1 = /** @type {((inputs?: Signupexport1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupexport1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupexport1(inputs)
	return de_signupexport1(inputs)
});
export { signupexport1 as "signupExport" }